import { defineComponent as _defineComponent } from 'vue'
import CarouselSwiper from '@/components/common/CarouselSwiper.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useIcons from '@/composables/useIcons'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrialOrPurchasedCoursesSlider',
  props: {
    courses: {
      type: Array as PropType<{ id: string; cardTeaserImageUrl: string; teaserImageUrl: string }[]>,
      required: true,
    },
  },
  setup(__props) {

  

  const { isDesktopDevice } = useBreakpoint()
  const { leftNavigation, rightNavigation } = useIcons()

  const breakPoints = {
    1200: {
      slidesPerView: '2',
      spaceBetween: '15',
      slidesPerGroup: '2',
    },
    1024: {
      slidesPerView: '1.2',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
    991: {
      slidesPerView: '1.45',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
    767: {
      slidesPerView: '1.2',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
    540: {
      slidesPerView: '1.2',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
  }

return { __sfc: true,isDesktopDevice, leftNavigation, rightNavigation, breakPoints, CarouselSwiper, useBreakpoint, useIcons, PlaceholderShimmer }
}

})